import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  makeSelectCategoryByPathCategory,
  makeSelectCategoryPathByPathCategory,
  makeSelectSubCategoryByPathCategory,
} from '~redux/menu/selectors';
import { useHeadContent } from '~view/hooks/head';
import BuyerListViewCategory from '~view/pages/buyer/ListViewCategory';

const ListViewSubCategory: React.FC = () => {
  const { category: pathCategory } = useParams<{ category: string }>();
  const { subcategory: pathSubCategory1 } = useParams<{
    subcategory: string;
  }>();
  const { subcategory2: pathSubCategory2 } = useParams<{
    subcategory2: string;
  }>();
  const pathSubCategory = useMemo(
    () =>
      `${pathSubCategory1}${pathSubCategory2 ? `/${pathSubCategory2}` : ''}`,
    [pathSubCategory1, pathSubCategory2]
  );
  // console.log(pathSubCategory);
  const categorySelector = useMemo(
    () => makeSelectCategoryByPathCategory(pathCategory, pathSubCategory),
    [pathCategory, pathSubCategory]
  );
  const category = useSelector(categorySelector);
  const categoryPathSelector = useMemo(
    () => makeSelectCategoryPathByPathCategory(pathCategory, pathSubCategory),
    [pathCategory, pathSubCategory]
  );
  const categoryPath = useSelector(categoryPathSelector);
  const subCategorySelector = useMemo(
    () => makeSelectSubCategoryByPathCategory(pathCategory, pathSubCategory),
    [pathCategory, pathSubCategory, pathSubCategory2]
  );
  const subCategory = useSelector(subCategorySelector);

  useHeadContent({
    title: `${subCategory}の卸売商品一覧`,
    breadcrumbs: [
      {
        text: 'トップ',
        url: process.env.REACT_APP_DOMAIN,
      },
      {
        text: category ?? '',
        url: encodeURI(`${process.env.REACT_APP_DOMAIN}${categoryPath}`),
      },
      {
        text: subCategory ?? '',
      },
    ],
  });

  if (!category || !subCategory) {
    return null;
  }

  return (
    <BuyerListViewCategory category={category} subCategory={subCategory} />
  );
};

export default ListViewSubCategory;
